import { useEffect, useState } from "react";
import { Clock, CalendarCheck } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { Loader, PageHeader } from "@/components/common";

export default function Coaching() {
  const [coaches, setCoaches] = useState(null);
  const [mine, setMine] = useState([]);
  const [book, setBook] = useState(null);
  const [f, setF] = useState({ preferred_time: "", note: "" });
  const load = () => api.get("/bookings").then((r) => setMine(r.data));
  useEffect(() => { api.get("/coaches").then((r) => setCoaches(r.data)); load(); }, []);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/bookings", { coach_id: book.coach.id, session_key: book.session.key, ...f });
      toast.success("Booking request sent — the coach will confirm by email.");
      setBook(null); setF({ preferred_time: "", note: "" }); load();
    } catch (err) { toast.error(errMsg(err)); }
  };
  if (!coaches) return <Loader />;
  return (
    <div data-testid="coaching-page">
      <PageHeader eyebrow="Get Coaching" title="Speak to a Business Coach" subtitle="A focused session with someone who has helped Mauritian founders launch." />
      <div className="grid md:grid-cols-2 gap-5 stagger">
        {coaches.map((c) => (
          <article key={c.id} className="sb-card overflow-hidden" data-testid={`coach-card-${c.id}`}>
            <div className="flex gap-4 p-5">
              <img src={c.image_url} alt={c.name} className="h-24 w-24 rounded-2xl object-cover object-top bg-[#F5F0E6]" />
              <div className="min-w-0">
                <h3 className="font-display font-extrabold text-lg">{c.name}</h3>
                <div className="text-xs font-bold text-[#179B80]">{c.specialty}</div>
                <p className="text-sm text-[#5C6B73] mt-1.5 line-clamp-3">{c.bio}</p>
              </div>
            </div>
            <div className="px-5 pb-2 text-xs text-[#5C6B73] flex items-center gap-1.5"><CalendarCheck className="h-3.5 w-3.5" />{c.availability}</div>
            <div className="divide-y divide-[#EADEC9] border-t border-[#EADEC9]">
              {c.session_types.map((s) => (
                <div key={s.key} className="flex items-center gap-3 p-4">
                  <div className="flex-1"><div className="font-semibold text-sm">{s.name}</div><div className="text-xs text-[#8C9BA5] flex items-center gap-1"><Clock className="h-3 w-3" />{s.minutes} min · {s.price}</div><div className="text-xs text-[#5C6B73] mt-0.5">{s.description}</div></div>
                  <button onClick={() => setBook({ coach: c, session: s })} className="sb-btn-primary min-h-[40px] text-xs px-4" data-testid={`book-call-btn-${c.id}-${s.key}`}>BOOK A CALL</button>
                </div>
              ))}
            </div>
          </article>
        ))}
      </div>
      {mine.length > 0 && (
        <section className="sb-card p-5 mt-6" data-testid="my-bookings">
          <div className="sb-eyebrow mb-3">My booking requests</div>
          {mine.map((b) => <div key={b.id} className="flex justify-between py-2 text-sm border-t border-[#EADEC9] first:border-0"><span>{b.session.name} · {b.coach_name}</span><span className="sb-chip bg-[#F5F0E6] text-[#5C6B73]">{b.status}</span></div>)}
        </section>
      )}
      <Dialog open={!!book} onOpenChange={(o) => !o && setBook(null)}>
        <DialogContent className="max-w-md rounded-3xl bg-[#FBF8F2]" data-testid="booking-dialog">
          <DialogHeader><DialogTitle className="font-display text-xl">{book?.session.name}</DialogTitle><DialogDescription>with {book?.coach.name} · {book?.session.minutes} min · {book?.session.price}</DialogDescription></DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <input required value={f.preferred_time} onChange={(e) => setF({ ...f, preferred_time: e.target.value })} placeholder="Preferred day & time" className="w-full h-12 rounded-xl border border-[#EADEC9] px-3 bg-white" data-testid="booking-time-input" />
            <textarea value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} rows={3} placeholder="What would you like help with?" className="w-full rounded-xl border border-[#EADEC9] p-3 bg-white" data-testid="booking-note-input" />
            <button className="sb-btn-primary w-full" data-testid="booking-submit-btn">Request booking</button>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}
